export const street = {
  params: [],
  validate(value: any) {
    return value?.match(/\d/) !== null
  },
}
